var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center"},_vm._l((_vm.units),function(unit,index){return _c('star-rating',{key:index,staticClass:"mr-1",class:_vm.starClasses,attrs:{"value":unit}},[_vm._v("\n    />\n  ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }